import { makeStyles } from "@fluentui/react-components";


export const useAppValidationHeroCardStyle = makeStyles({
  learnMoreButton: {
    padding: "0px",
    display: "flex",
    justifyContent: "flex-start"
  },
  iconMargin: {
    marginTop: "4px",
    marginLeft: "4px"
  },
  heroMargin: {
    marginTop: "18px"
  },
});

export const useOverviewCardStyles = makeStyles({
  card: { width: "100%", padding: "16px 32px" },
  flex: { height: "184px", marginTop: "12px" }
})
